var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4258 8.095L1.42576 0.0949991C1.25458 0.0144495 1.06406 -0.0158879 0.876322 0.00751001C0.688587 0.0309079 0.511339 0.107081 0.365164 0.227184C0.218988 0.347287 0.109881 0.506392 0.0505117 0.686023C-0.00885731 0.865655 -0.0160522 1.05844 0.0297628 1.242L1.24176 6.091L8.99976 9L1.24176 11.909L0.0297628 16.758C-0.0169142 16.9417 -0.0103198 17.1349 0.0487745 17.315C0.107869 17.495 0.21702 17.6546 0.363459 17.7749C0.509899 17.8952 0.687572 17.9713 0.875696 17.9944C1.06382 18.0174 1.25461 17.9864 1.42576 17.905L18.4258 9.905C18.5976 9.82424 18.7428 9.69626 18.8446 9.536C18.9463 9.37574 19.0004 9.18983 19.0004 9C19.0004 8.81017 18.9463 8.62426 18.8446 8.464C18.7428 8.30374 18.5976 8.17576 18.4258 8.095Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/ArrowRightBlack.6ddc0fae43167b2f1284f00d3e465098.svg";
export { ForwardRef as ReactComponent };